import React from 'react';
import TokenWithNetwork from '../../../../Common/TokenWithNetwork/TokenWithNetwork';
import { getValueByMultiProps } from '../../../../../utils/mapper';
import SignStatus from './SignStatus/SignStatus';
import TokenPrice from '../../../../Common/SliderTokensList/SliderToken/TokenPrice/TokenPrice';
import { TooltipedNumber } from '../../../../Common/TooltipedNumber/TooltipedNumber';
import config from '../../../../../config/config.json';

export const signTradeOrdersCols = ({ signMethod, loading }) => [
  {
    id: '',
    title: '',
    render: (record) => (
      <div
        className="gap-sm d-flex align-items-center"
        style={{
          padding: '0 1rem',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <TokenWithNetwork
          token={{
            ...record,
            name: getValueByMultiProps(record, ['token_name', 'name']),
            percentage: getValueByMultiProps(record, ['token_ratio', 'percentage']),
            token_id: getValueByMultiProps(record, ['token_id', 'id']),
            network: 'binance',
            image: getValueByMultiProps(record, [
              'image',
              'token_image_thumb',
              'token_image_small',
              'token_image_large',
            ]),
          }}
        />
        <span className="mx-3">{getValueByMultiProps(record, ['token_name', 'name'])}</span>
      </div>
    ),
  },
  {
    id: 'ratio',
    title: 'Token Percentage',
    render: (record) => (
      <span>{`${getValueByMultiProps(record, ['token_ratio', 'percentage', 'current_ratio_from_pool'])}%`}</span>
    ),
  },
  {
    id: 'amount',
    title: 'Token Amount',
    render: (record) => (
      <div className="flex-centered">
        <TooltipedNumber number={record?.current_state_amount} show={false} />
        <span className="mx-1">{record?.token_symbol}</span>
      </div>
    ),
  },
  {
    id: 'tokenUsTotal',
    title: '',
    render: (token) => (
      <TokenPrice token={token}>
        {({ usdEqValue }) => <span>${(usdEqValue * token?.current_state_amount || 0)?.toFixed(3)}</span>}
      </TokenPrice>
    ),
  },
  {
    id: 'tokenEthTotal',
    title: '',
    render: (token) => (
      <TokenPrice token={token}>
        {({ ethEqValue }) => (
          <span className="white-space-pre">
            {(ethEqValue * token?.current_state_amount || 0)?.toFixed(3)} {config.baseCoin.toUpperCase()}
          </span>
        )}
      </TokenPrice>
    ),
  },
  {
    id: '_status',
    title: '',
    render: (record) => (
      <SignStatus
        tokenAddress={record.token_address}
        tokenRatio={record.token_ratio}
        tokenId={record.token_id}
        isExecuted={record.is_executed}
        tradeOrderId={record.id}
        token={record}
        signMethod={signMethod}
        loading={loading}
      />
    ),
  },
];
